import React from "react";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";

import Typography from "../Typography/Typography";

import styles from "./BadgeOffline.module.scss";

const BadgeOffline = () => {
  const { t } = useSharedTranslation();
  return (
    <Typography
      data-draggable
      className={styles["badge-offline"]}
      variant="body3"
    >{t("sw:offline")}</Typography>
  );
};

export default BadgeOffline;
